export const TITLE_FIELD_NAME = 'title'
export const TEMPLATE_FIELD_NAME = 'template'
export const BODY_CONTENT_FIELD_NAME = 'bodyContent'
export const HEAD_CONTENT_FIELD_NAME = 'headContent'

export enum UploaderFileExtension {
  HTML = 'text/html',
}
